import _ from "lodash";
import produce from "immer";

export function initialStateObject(item = undefined) {
	return {
		fetchStatus: undefined,
		item,
		pastItems: [],
		futureItems: [],
		stateSnapshots: {},
		didRedo: false,
		didUndo: false,
	};
}

export function initialStateObjectCollection(items = [], itemsById = {}) {
	return {
		fetchStatus: undefined,
		items,
		stateSnapshots: {},
		itemsById,
	};
}

export function undoStateItem(state) {
	if (state.pastItems.length) {
		const newState = _.cloneDeep(state);
		const previousItem = newState.pastItems[state.pastItems.length - 1];
		const newPastItems = newState.pastItems.slice(
			0,
			state.pastItems.length - 1
		);
		newState.item = previousItem;
		newState.pastItems = newPastItems;
		newState.futureItems = [state.item, ...newState.futureItems];
		newState.didUndo = true;
		newState.didRedo = false;
		return newState;
	} else {
		return state;
	}
}

export function redoStateItem(state) {
	// debugger;
	if (state.futureItems.length) {
		const newState = _.cloneDeep(state);
		const nextItem = newState.futureItems[0];
		const newFutureItems = newState.futureItems.slice(1);
		newState.item = { ...nextItem };
		newState.pastItems = [...state.pastItems, state.item];
		newState.futureItems = [...newFutureItems];
		newState.didUndo = false;
		newState.didRedo = true;
		return newState;
	} else {
		return state;
	}
}

export function updateStateItem(state, item) {
	const stateCopy = _.cloneDeep(state);
	const newState = {
		...stateCopy,
		item: updateObject(state.item, item),
		futureItems: [],
		didUndo: false,
		didRedo: false,
	};
	state.item && newState.pastItems.push(state.item);
	return newState;
}

export function makeStateSnapshot(state, item) {
	const newState = _.cloneDeep(state);
	const snapshot = _.omit(newState, "stateSnapshots");
	newState.stateSnapshots[item.key] = snapshot;
	return newState;
}

export function restoreStateSnapshot(state, item) {
	const newState = _.cloneDeep(state);
	const stateSnapshots = newState.stateSnapshots;
	const stateSnapshot = newState.stateSnapshots[item.key];
	return stateSnapshot ? { ...stateSnapshot, stateSnapshots } : newState;
}

export function updateItemInState(state, oldItem, newItem) {
	return (Object.assign({}, state).item = updateObject(oldItem, newItem));
}

export function updateItemInStateItems(state, newItem) {
	const nextState = produce(state, (draft) => {
		if (draft.itemsById[newItem.id] === undefined) {
			draft.itemsById[newItem.id] = {};
		}

		for (const key in newItem) {
			draft.itemsById[newItem.id][key] = newItem[key];
		}

		const index = draft.items.findIndex((item) =>
			newItem.id ? item.id === newItem.id : item._id === newItem._id
		);
		if (index !== -1) {
			for (const key in newItem) {
				draft.items[index][key] = newItem[key];
			}
		} else {
			draft.items.push(newItem);
		}
	});

	return nextState;
}

export function updateItemsInStateItems(state, items) {
	items.forEach((item) => {
		state = updateItemInStateItems(state, item);
	});

	return state;
}

export function resetItemsInStateItems(state) {
	return _.cloneDeep(state);
}

export function addItemInStateItems(state, item) {
	let stateCopy = _.cloneDeep(state);
	let itemsCopy = [...stateCopy.items];
	itemsCopy.push(item);
	stateCopy.itemsById[item.id] = item;
	return Object.assign({}, state, { items: itemsCopy });
}

export function removeItemInStateItems(state, item) {
	let stateCopy = _.cloneDeep(state);
	let itemsCopy = [...stateCopy.items];
	delete stateCopy.itemsById[item.id];
	return Object.assign({}, state, {
		items: removeItemInArray(itemsCopy, item),
	});
}

export function removeItemsInStateItems(state, item) {
	let stateCopy = _.cloneDeep(state);
	let itemsCopy = [...stateCopy.items];
	const itemsToRemove = itemsCopy.filter((itemCopy) =>
		item.ids.includes(itemCopy.id)
	);
	itemsToRemove.forEach((itemToRemove) => {
		delete stateCopy.itemsById[itemToRemove.id];
	});
	return Object.assign({}, state, {
		items: removeItemsInArray(itemsCopy, itemsToRemove),
	});
}

export function removeValueInState(state, key) {
	let stateCopy = Object.assign({}, state);
	delete stateCopy[key];
	return stateCopy;
}

export function removeValueInStateItem(state, key) {
	let stateCopy = Object.assign({}, state);
	delete stateCopy.item[key];
	return stateCopy;
}

// Array and Object utils

export function updateObject(oldObj, newObj) {
	return Object.assign({}, oldObj, newObj);
}

export function removeItemInArray(array, item) {
	let arrayCopy = [...array];
	const itemIndex = arrayCopy.findIndex((oldItem) =>
		item.id ? oldItem.id === item.id : oldItem._id === item._id
	);
	if (itemIndex > -1) {
		arrayCopy.splice(itemIndex, 1);
	}

	return arrayCopy;
}

export function removeItemsInArray(array, items) {
	let newArray = array;
	items.forEach((item) => {
		newArray = removeItemInArray(newArray, item);
	});
	return newArray;
}
